import { useEffect, useState, useRef } from "react"
import { getAportantes, setAportante, setDatosAportante, updateAportante } from '../componentes/api.js';
import { RUTA_SERVER } from '../componentes/config.js';
import Modal from '../comun/VentanaModal.jsx'
import TextField from '@mui/material/TextField';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import BarraBotones from "../comun/BarraBotones.jsx";
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider';
import NoFoto from '../assets/noFoto.jpg';


const AportantesLogo =(props)=>{
  const testRef = useRef(null);
  const scrollToElement = () => testRef.current.scrollIntoView();
  const [datos, setDatos] = useState([])
  const [cant, setCant] = useState(0)
  const [registro, setRegistro] = useState({
    Id:'',
    Nbre:'',
    Logo:'',
    Activo: true
  });
  

  /*** Para muestra preliminar de las Imágenes ***** */
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  
   /** Para el manejo de la ventana de mensajes modal**/
   const [show, setShow] = useState(false);
   const [msg, setMsg] = useState([]);
   const handleClose = () => setShow(false);

  

  useEffect(() =>{
    cargarDatos();
  },[]);

  const asignarDato =(event)=>{
    event.preventDefault();
    if(event.target.name === 'Activo'){
      setRegistro({...registro, [event.target.name]: event.target.checked})

    }else{
      setRegistro({...registro, [event.target.name]: event.target.value})
    }
    
  }

  const cargarDatos = async()=>{
    try {
      const response = await getAportantes()
      setDatos(response.data)
      setCant(response.data.length)
            
    } catch (error) {
      mostrarMsg(["ERROR", "Ocurrio un error al cargar los datos el Grid de las entidades Aportantes", error])
    }
  }

  const botones=(btn)=>{
    if(btn===0) nuevo();
    else if(btn===1) validarDatos();
    else if(btn===2) imprimir();
    else if(btn===3) exportar();
    else if(btn===4) nuevo();
  }

  const imprimir =()=>{
    mostrarMsg(["OK, Imprime los datos"])
  }

  const exportar =()=>{
    mostrarMsg(["OK, exportará los datos"])
  }
  
  const cargarFila = (event, reg)=>{
    event.preventDefault();
    if(reg.Logo!==null && reg.Logo!==''){
     
      setFileUrl(RUTA_SERVER + "/" + reg.Logo)
    }else{
      setFileUrl(null)
    }
    
    setRegistro({
      Id: reg.Id,
      Nbre: reg.Nbre,
      Logo: reg.Logo,
      Activo: reg.Activo==='Activo' ? true : false
    })
    scrollToElement()
  }
  
  const mostrarMsg = (msg)=>{
    setMsg(msg)
    setShow(true)
  }

  const validarDatos = ()=>{
    if(registro.Nbre===''){
      mostrarMsg(["Por favor digite el Nombre"])

    }else{
      {registro.Id==='' ? grabarRegistro() : modificarRegistro()}
    }

  }

  const grabarRegistro = async()=>{
    try {
      if(file===null){    //No hay logo
        let dato = {Nbre: registro.Nbre, Logo: '', Activo: registro.Activo ? 1:0, IdUsuario: props.idUsuario}
        const response = await setDatosAportante(dato)
        setRegistro({...registro, ['Id']: response})
        cargarDatos();
        mostrarMsg(["Felicidades!!!", "Entidad " + registro.Nbre + " Creada!"])

      }else{              //Se graban los datos con la imagen del logo
        /** Formateo los datos que enviaré */
        const formdata = new FormData();
        formdata.append('Id', registro.Id);
        formdata.append('Nbre', registro.Nbre);
        formdata.append('Activo', registro.Activo ? 1 : 0);
        formdata.append('IdUsuario', props.idUsuario);
        formdata.append('image', file)
        const response = await setAportante(formdata)
        setRegistro({...registro, ['Id']: response})
        cargarDatos();
        mostrarMsg(["Felicidades!!!", "Entidad " + registro.Nbre + " Creada!"])

      }
    } catch (error) {
      mostrarMsg(["ERROR", "Ocurrio un error al crear la Entidad Aportante!", error])
    }
  }

  const handleChange = (e) => {
    //console.log(e.files[0].type)
    setFile(e.files[0])
    setRegistro({...registro, ['Logo']: e.files[0].name})
    let fileReader;
    if (e.files[0]) {
      fileReader = new FileReader();
      fileReader.onload = (e) => {
        const { result } = e.target;
        if (result) {
          setFileUrl(result)
         
        }
      }
      fileReader.readAsDataURL(e.files[0]);
      
    }
  }

  const modificarRegistro = async()=>{
    if(file===null){    //No hay logo
      let dato = {Id: registro.Id, Nbre: registro.Nbre, Logo: '', Activo: registro.Activo ? 1:0, IdUsuario: props.idUsuario}
      const response = await updateAportante(dato)
      cargarDatos();
      mostrarMsg(["Felicidades!!!", "Entidad Modificada!"])

    }else{
      try {
        /** Formateo los datos que enviaré */
        const formdata = new FormData();
        formdata.append('Id', registro.Id);
        formdata.append('Nbre', registro.Nbre);
        formdata.append('Activo', registro.Activo ? 1 : 0);
        formdata.append('IdUsuario', props.idUsuario);
        formdata.append('image', file)
        
        const response = await setAportante(formdata)
        cargarDatos();
        mostrarMsg(["Felicidades!!!", "Entidad Modificada!"])

      } catch (error) {
        mostrarMsg(["ERROR", "Ocurrio un error al Modificar los Datos de la entidad.", error])
      }
    }
  }

  const nuevo =()=>{
    setFile(null)
    setFileUrl('')
    setRegistro({
      Id:'',
      Nbre:'',
      Logo:'',
      Activo: true
    })
  }

  return(
    <div className="container-fluid" ref={testRef}>
      <div className="row card mt-3 mb-3">
        <Alert severity="success"><strong>ENTIDADES APORTANTES</strong></Alert>

        <div className="row mt-3">
          <BarraBotones botones={botones} btnActivos={[true, true, false, true, true]}/>
        </div>
      
      <div className="row">
        <div className="col-sm-4">
            <img 
              className='img-fluid card-img-top text-center' 
              style={{width:'200', height:'140', textAlign:'center'}}
              src={fileUrl || NoFoto} 
              alt={'Imagen'} 
            />
        </div>
        
        <div className="col-sm-8">
          <div className="row mb-3">
            <TextField
              name="Id"
              label="ID"
              className="form-control"
              type="text"
              value={registro.Id}
              disabled
            />
          </div>

          <div className="row mb-3">
            <TextField
              autoFocus={true}
              name="Nbre"
              label="Nombre de la Entidad"
              className="form-control"
              type="text"
              value={registro.Nbre}
              onChange={asignarDato}
            />
          </div>

          <div className="row text-center">
            <input 
              className='form-control mt-3'
              type="file" 
              name="archivo" 
              id="archivo"
              //accept={datosAnexo.formato} 
              onChange={(e) => handleChange(e.target)} //multiple 
            />
          </div>
        </div>
      </div>

      <div className="row">
        <FormGroup>
          <FormControlLabel 
            name="Activo"
            control={
              <Switch
                checked={registro.Activo}
                onChange={asignarDato}
                inputProps={{ 'aria-label': 'Activo' }} 
                //defaultChecked
              />
            
            } 
            label={datos.activo===true ? "Estado: Aportante ACTIVO" : "Estado: Aportante ANULADO" }
              labelPlacement="start"
            />
          </FormGroup>
        </div>  
      </div>

      <Divider component="ul" />
      <div className="row mt-3">
        <BarraBotones botones={botones} btnActivos={[true, true, false, true, true]}/>
      </div>

        
      <div className="row card">
        <h3 className="mt-3 mb-3">LISTADO DE ENTIDADES APORTANTES - Cantidad: {cant}</h3>
        <table className="table table-hover table-bordered">
          <thead className="table-primary">
            <tr>
              <th scope="col"># ITEM</th>
              <th scope="col">NOMBRE</th>
              <th scope="col" className="text-center">ESTADO</th>
              <th scope="col" className="text-center">ACCION</th>
            </tr>
          </thead>
          <tbody>
            {datos.map((reg, i)=>{
              return(
              <tr className={reg.Activo==='Inactivo'? "table-danger":""} key={i}>
                <th> {i+1} </th>
                <th> {reg.Nbre} </th>
                <th> {reg.Activo} </th>
                <th> 
                  <a href="#divTop"
                    className="btn btn-primary form-control"
                    onClick={(event) =>{cargarFila(event, reg)}}
                  >Editar 
                  </a>
                </th>
              </tr>
              )})} 
          </tbody>
        </table>
      </div>
      <Modal show={show} handleClose={handleClose} msg={msg} />
    </div>
  )
}

export default AportantesLogo